import {
  Expenses,
  ServerExpensesFetch,
  ClearExpensesErrorAction,
  CreateExpensesAction,
  CreateExpensesFailAction,
  CreateExpensesSuccessAction,
  DeleteExpensesAction,
  DeleteExpensesFailAction,
  DeleteExpensesSuccessAction,
  FetchExpensesAction,
  FetchExpensesFailAction,
  FetchExpensesSuccessAction,
  SetExpensesErrorAction,
  UpdateExpensesAction,
  UpdateExpensesFailAction,
  UpdateExpensesAbortAction,
  UpdateExpensesSuccessAction,
  UpsertExpensesAction,
  UpsertExpensesFailAction,
  UpsertExpensesSuccessAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function clearExpensesError(): ClearExpensesErrorAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.CLEAR_EXPENSES_ERROR };
}

export function createExpenses(applicationId: string, expenses: Expenses): CreateExpensesAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.CREATE_EXPENSES, applicationId, expenses };
}

export function createExpensesFail(clientId: string): CreateExpensesFailAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.CREATE_EXPENSES_FAIL, clientId };
}

export function createExpensesSuccess(clientId: string, id: string): CreateExpensesSuccessAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.CREATE_EXPENSES_SUCCESS, clientId, id };
}

export function deleteExpenses(applicationId: string, clientId: string, applicantId: string): DeleteExpensesAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.DELETE_EXPENSES, applicationId, clientId, applicantId };
}

export function deleteExpensesFail(clientId: string): DeleteExpensesFailAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.DELETE_EXPENSES_FAIL, clientId };
}

export function deleteExpensesSuccess(): DeleteExpensesSuccessAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.DELETE_EXPENSES_SUCCESS };
}

export function fetchExpenses(applicationId: string, applicantId?: string): FetchExpensesAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.FETCH_EXPENSES, applicationId, applicantId };
}

export function fetchExpensesFail(): FetchExpensesFailAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.FETCH_EXPENSES_FAIL };
}

export function fetchExpensesSuccess(expenses: ServerExpensesFetch[]): FetchExpensesSuccessAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.FETCH_EXPENSES_SUCCESS, expenses };
}

export function setExpensesError(message: string = 'Unknown error'): SetExpensesErrorAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.SET_EXPENSES_ERROR, message };
}

export function updateExpenses(applicationId: string, expenses: Expenses): UpdateExpensesAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES, applicationId, expenses };
}

export function updateExpensesFail(clientId: string): UpdateExpensesFailAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES_FAIL, clientId };
}

export function updateExpensesAbort(): UpdateExpensesAbortAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES_ABORT };
}

export function updateExpensesSuccess(): UpdateExpensesSuccessAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES_SUCCESS };
}

export function upsertExpenses(applicationId: string, expenses: Expenses[]): UpsertExpensesAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.UPSERT_EXPENSES, applicationId, expenses };
}

export function upsertExpensesFail(): UpsertExpensesFailAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.UPSERT_EXPENSES_FAIL };
}

export function upsertExpensesSuccess(): UpsertExpensesSuccessAction {
  return { type: REDUX_STORE.EXPENSES.ACTION_TYPES.UPSERT_EXPENSES_SUCCESS };
}
